import { useEffect, useCallback, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { UserContext } from "../context/UserContext";
import { logout as logoutApi, getUserFromToken } from "../api/authApi";
import { setUnauthorizedHandler } from "../api/axiosSetup";
import { useInactivityLogout } from "../hooks/useInactivityLogout";

const SessionManager = ({ children }) => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const clearingRef = useRef(false);

  const clearSession = useCallback(
    async (message) => {
      if (clearingRef.current) return;
      clearingRef.current = true;
      try {
        await logoutApi();
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setUser(null);
        if (message) toast.warning(message);
        navigate("/login", { replace: true });
      } finally {
        clearingRef.current = false;
      }
    },
    [navigate, setUser],
  );

  const clearSessionRef = useRef(clearSession);
  clearSessionRef.current = clearSession;

  useEffect(() => {
    setUnauthorizedHandler((msg) => {
      clearSessionRef.current(msg || "Session expired. Please log in again.");
    });
  }, []);

  useEffect(() => {
    if (!user) return;
    const tokenUser = getUserFromToken();
    if (!tokenUser?.sessionId) {
      clearSessionRef.current("Session expired. Please log in again.");
    }
  }, [user]);

  useInactivityLogout(Boolean(user), () => {
    clearSessionRef.current("Logged out due to 15 minutes of inactivity.");
  });

  return children;
};

export default SessionManager;
